import { emsToDisplay } from '../../../../services/utils/DateFormat';

/**
 * MetaDataInjector
 *
 * Enriches parsed data note JSON with entry metadata before template injection.
 * Metadata is stored under data._meta — templates access it via data._meta.xxx.
 *
 * Convention: the data note is a translation layer between Entry and Renderer.
 * Entry fields are injected into _meta so templates can always access them.
 *
 * Title priority: data.title (user edited inline) > entry.title (fallback)
 */
export const injectMetaData = (parsed, entry, templateName, dateFormat) => {
    return {
        ...parsed,
        // CHANGED — data.title has priority (user can edit inline), entry.title as fallback
        title: parsed.title || entry.title || '',
        subtitle: parsed.subtitle ?? '',
        _meta: {
            importanceId: entry.importanceId ?? null,
            category: entry.cat ?? null,
            templateName: templateName ?? null,
            entryTitle: entry.title ?? null,
            entryService: entry.service ?? null,
            createdOn: parsed.createdOn ? emsToDisplay(parsed.createdOn, dateFormat) : null,
            updatedOn: parsed.updatedOn ? emsToDisplay(parsed.updatedOn, dateFormat) : null,
            entryDate: entry.ems ? emsToDisplay(entry.ems, dateFormat) : null,
            service: entry.service ?? null,
            ...(parsed._meta ?? {}),
        }
    };
};
